import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Palette, Box, Activity, Zap, Layers, Sparkles } from 'lucide-react';

export default function SolutionPrototyping() {
  return (
    <SubpageTemplate 
      title="Rapid Prototyping"
      subtitle="Fidelity at Speed"
      description="Don't just show slides. Build functional, interactive prototypes that look and feel like the final product in minutes."
      icon={Box}
      features={[
        {
          title: "Interactive Synthesis",
          description: "Generate user flows and interaction logic automatically from your design briefs.",
          icon: Activity
        },
        {
          title: "High Fidelity",
          description: "Production-grade UI components that are ready to be exported to live environments.",
          icon: Palette
        },
        {
          title: "Instant Feedback",
          description: "Shareable preview links to get stakeholder approval before engineering begins.",
          icon: Sparkles
        }
      ]}
    />
  );
}
